import { useNavigate } from "react-router-dom";
import "./DashboardStart.css";

function DashboardStart() {
 const navigate = useNavigate();

 return (
  <div className="dashboard-start-page">
   <div className="dashboard-start-shell dashboard-start-grid">
    {/* LEFT */}
    <div className="dashboard-start-left">
     <h1>Create your page</h1>
     <p className="dashboard-start-sub">
      A simple public page for your league, club, team, training, facility, or school.
     </p>

     <div className="dashboard-start-steps">
      <div className="step-row">
       <div className="step-num">1</div>
       <div className="step-text">Pick a style (colors + cover)</div>
      </div>
      <div className="step-row">
       <div className="step-num">2</div>
       <div className="step-text">Add your info + links</div>
      </div>
      <div className="step-row">
       <div className="step-num">3</div>
       <div className="step-text">Publish in one click</div>
      </div>
      <div className="step-row">
       <div className="step-num">4</div>
       <div className="step-text">Get your URL</div>
      </div>
      <div className="step-row">
       <div className="step-num">5</div>
       <div className="step-text">Get discovered on SportingHip</div>
      </div>
     </div>
    </div>

    {/* RIGHT */}
    <div className="dashboard-start-right">
     <div className="start-action-card">
      <button
       className="primary-btn"
       onClick={() => navigate("/dashboard/page-wizard")}
      >
       Create my page
      </button>

      <small className="hint">
       Already listed on SportingHip? Find your page and click <strong>Claim</strong>.
      </small>
     </div>

     <div className="dashboard-start-footer">
      <small>Free to start • Upgrade anytime</small>
     </div>
    </div>
   </div>
  </div>
 );
}

export default DashboardStart;